export var COMPONENT_SPACING = '20px';
export var COMMON_HORIZONTAL_SPACING = '18px';
export var COMMON_VERTICAL_SPACING = '12px';
export var LIST_SPACING = '10px';
export var HORIZONTAL_ICON_SPACING = '8px';
export var VERTICAL_ICON_SPACING = '6px';
export var HORIZONTAL_MINI_SPACING = '4px';
export var VERTICAL_MINI_SPACING = '6px';
export var HORIZONTAL_SMALL_BUTTON_SPACING = '8px';